import {request,newVue,requestMsg} from "./request";
export {newVue}

export function getMerchantsBySearch(merchantsClassify,merchantsName,name,detailAddress,pageNum,pageSize) {
  return request({
    url: '/merchants/getMerchantsList',
    params: {
      merchantsClassify: merchantsClassify,
      merchantsName: merchantsName,
      name: name,
      detailAddress: detailAddress,
      pageNum: pageNum,
      pageSize: pageSize
    }
  })
}

export function delByMerchantsId(id) {
  return requestMsg({
    url: '/merchants/delByMerchantsId',
    params: {
      merchantsId:id
    }
  })
}

export function getMerchantsById(id) {
  return request({
    url: '/merchants/getById',
    params: {
      merchantsId:id
    }
  })
}

export function updateMerchants(merchants) {
  let address = "";
  for (let i = 0;i<merchants.detailAddress.length;i++){
    address = address + merchants.detailAddress[i]
  }
  merchants.detailAddress = address;
  return requestMsg({
    url: '/merchants/updateMerchants',
    data: JSON.stringify(merchants),
    method: "POST",
    headers : {"Content-Type" : "application/json;charset=utf-8"},
  })
}
